/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styled from "styled-components";
import { Link, Redirect } from "react-router-dom";
import { Typography } from "../Components/Typography";
import RecorvyPasswordHooks from "../hooks/RecorvyPasswordHooks";
import Loading from "../Components/Loading";
import CONSTANTS from "../constants";
import { Divider } from "../Components/Divider";
import {FlexCenter} from "../Components/layout/FlexCenter";

export const Forms = styled.form`
  border-radius: 0px 50px 0px 50px;
  box-shadow: 10px 10px 10px 5px #080808;
  margin-top: 10px;
`;

export const SubmitInput = styled.input`
  padding: 10px;
  height: 50px;
  border: none;
  border-radius: 8px;
  background: ${(props) => (props.primary ? "palevioletred" : "#9b59b6")};
  cursor: ${(props) => (props.loading ? "progress" : "pointer")} !important;
  color: #fff;
  margin: 20px;
  font-weight: bold;
`;

function RecoveryPassword() {
  const hook = RecorvyPasswordHooks();
  const { loading, hasTokenRequest, errorResponse } = hook;
  if (errorResponse)
    return (
      <>
        <Redirect to={CONSTANTS.APP.SERVICE_UNAVAILABLE} />
      </>
    );
  if (loading && hasTokenRequest && hook.expiredToken == null)
    return <Loading full={true} label={loading} />;
  return <Recovery content={Content(hook)} loading={loading} />;
}

const Recovery = ({ loading, content }) => (
  <div
    className="container d-flex mt-5 flex-column align-items-center"
    style={{
      maxWidth: "450px",
    }}
  >
    <img src="logo.png" width={180} alt="Codivas" className="mb-3" />

    <Forms
      onSubmit={content.handle}
      className=" d-flex flex-column border p-5 "
      name="login"
      style={{ height: "fit-content", textAlign: "center" }}
    >
      <div
        class="form-group d-flex flex-column justify-content-between"
        style={{
          height: "fit-content",
          border: "1px solid transparent",
          gap: "16px",
        }}
      >
        {<content.Content />}
        <Divider />
        <SubmitInput
          type="submit"
          name=""
          loading={loading}
          value={loading ? loading : content.send}
        />
        <content.Section />
      </div>

      <ul className="social-network social-circle d-flex mt-2 justify-content-around">
        <li>
          <a
            href="https://github.com/Codivas"
            className="icoGitHub"
            title="Github"
          >
            <FontAwesomeIcon icon={["fa", "code-branch"]} />
          </a>
        </li>
        <li>
          <a
            href="https://www.instagram.com/as.codivas/"
            className="icoInstagram"
            title="Instagran"
          >
            <FontAwesomeIcon icon={["fa", "camera-retro"]} />
          </a>
        </li>
      </ul>
    </Forms>
  </div>
);

const Content = (props) => {
  const pages = {
    contentHasSendNewToken: {
      handle: props.handleHasSend,
      Content: ContentHasSendNewToken,
      send: "Login",
      Section: () => (
        <FooterTipsRegisterComponents label="Problemas?" labelLink="Suporte" />
      ),
    },
    contentHasSend: {
      handle: props.handleHasSend,
      Content: ContentHasSend,
      send: "Login",
      Section: () => (
        <FooterTipsRegisterComponents label="Problemas?" labelLink="Suporte" />
      ),
    },
    contentExpiredToken: {
      handle: props.handleRedirect,
      Content: ContentExpiredToken,
      send: "Solicitar novamente",
      Section: () => (
        <FooterTipsRegisterComponents label="Problemas?" labelLink="Suporte" />
      ),
    },
    contentNewPassword: {
      handle: props.handleNewPassword,
      Content: ContentNewPassword,
      send: "Salvar",
      Section: () => (
        <>
          <Typography className="mb-3">
            Siga a gente nas redes sociais
          </Typography>
        </>
      ),
    },
    contentRecorvyPassword: {
      handle: props.handleRecorvy,
      Content: ContentRecoveryPassword,
      send: "Recuperar Senha",
      Section: () => (
        <FooterTipsRegisterComponents
          label="Deseja criar uma nova conta?"
          labelLink="Cadastra-se"
          to={CONSTANTS.APP.REGISTER}
        />
      ),
    },
  };

  if (props.hasSend && props.hasTokenRequest)
    return pages.contentHasSendNewToken;
  if (props.hasSend) return pages.contentHasSend;
  if (props.expiredToken) return pages.contentExpiredToken;
  if (props.hasTokenRequest) return pages.contentNewPassword;
  if (!props.hasTokenRequest) return pages.contentRecorvyPassword;

  throw new TypeError("invalid option");
};

const ContentRecoveryPassword = () => (
  <>
    <Typography fontSize="1.3"> Voltando para sua conta da CODIVAS!</Typography>
    <Typography className="text-muted">
      Informe o email de cadastro que será reenviado o link de recuperação de
      senha.
    </Typography>
    <input
      className="form-control"
      type="email"
      name="email"
      placeholder="E-mail"
      required
    />
  </>
);

const ContentNewPassword = () => (
  <>
    <Typography fontSize="1.3">
      {" "}
      Bem vinda de volta ao Portal CODIVAS!
    </Typography>
    <Typography className="text-muted">Insira a sua nova senha</Typography>
    <input
      className="form-control"
      type="password"
      name="password"
      placeholder="Nova Senha"
      required
    />
  </>
);

const ContentExpiredToken = () => (
  <>
    <Typography fontSize="1.3">
      {" "}
      Bem vinda de volta ao Portal CODIVAS!
    </Typography>
    <Typography className="text-muted">
      Desculpa, mas essa token se encontra inválida. Por favor recupere a senha
      novamente.
    </Typography>
  </>
);

const ContentHasSend = () => (
  <>
    <Typography fontSize="1.3">
      {" "}
      Solicitação de recuperação de senha enviada com sucesso!
    </Typography>
    <Typography className="text-muted">
      Em breve chegará um email com instruções para recuperar a senha.
    </Typography>
  </>
);

const ContentHasSendNewToken = () => (
  <>
    <Typography fontSize="1.3"> Senha atualizada com sucesso!</Typography>
    <Typography className="text-muted"></Typography>
  </>
);

export const FooterTipsRegisterComponents = ({ label, to = "#", labelLink }) => (
  <>
      <FlexCenter>
          <Typography className={"text-muted"} fontSize={"0.5"}>{label}{" "}</Typography>
          <Typography fontSize={"0.8"}>
              <Link to={to} className="nav-link d-inline">
                  {labelLink}
              </Link>
          </Typography>
      </FlexCenter>
  </>
);

export default RecoveryPassword;
